import { Navigate, useLocation } from "react-router-dom";

interface ChannelRedirectProps {
  to: string;
}

/** Old per-type tab links land on the page that replaced them, query kept. */
export const ChannelRedirect = ({ to }: ChannelRedirectProps) => {
  const { search } = useLocation();

  return <Navigate replace to={{ pathname: to, search }} />;
};
